import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@core/config/routes'

export const investorsRoutes: RouteRecordRaw[] = [
  {
    path: routes.INVESTOR,
    name: 'INVESTOR',
    component: () => import('./pages/InvestorsManagementPage.vue'),
    meta: { title: 'Investor Management', requiresAuth: true },
  },
  {
    path: routes.INVESTOR_DETAILS,
    name: 'INVESTOR_DETAILS',
    component: () => import('./pages/InvestorDetailsPage.vue'),
    meta: { title: 'Investor Details', requiresAuth: true, activeMenu: 'Investors' },
  },
  {
    path: routes.INVESTORS_ALL,
    name: 'INVESTORS_ALL',
    component: () => import('./pages/InvestorsAllPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Investors' },
  },
  {
    path: routes.INVESTORS_REJECTED,
    name: 'INVESTORS_REJECTED',
    component: () => import('./pages/InvestorsRejectedPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Investors' },
  },
  {
    path: routes.INVESTORS_BLOCKED,
    name: 'INVESTORS_BLOCKED',
    component: () => import('./pages/InvestorsBlockedPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Investors' },
  },
  {
    path: routes.INVESTORS_KYC_PENDING,
    name: 'INVESTORS_KYC_PENDING',
    component: () => import('./pages/InvestorKycPendingPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Investors' },
  },
  {
    path: routes.INVESTORS_ONBOARDING_REVIEW,
    name: 'INVESTORS_ONBOARDING_REVIEW',
    component: () => import('./pages/InvestorOnboardingReviewPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Investors' },
  },
  {
    path: routes.INVESTORS_BANK_VERIFICATIONS,
    name: 'INVESTORS_BANK_VERIFICATIONS',
    component: () => import('./pages/InvestorBankVerificationsPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Investors' },
  },
  {
    path: routes.INVESTORS_VASP_ONBOARDING,
    name: 'INVESTORS_VASP_ONBOARDING',
    component: () => import('./pages/InvestorVaspOnboardingPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Investors' },
  },
  {
    path: routes.INVESTORS_KYC_EXPIRED,
    name: 'INVESTORS_KYC_EXPIRED',
    component: () => import('./pages/InvestorKycExpiredPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Investors' },
  },
  {
    path: routes.INVESTORS_PIPELINE,
    name: 'INVESTORS_PIPELINE',
    component: () => import('./pages/InvestorOnboardingPipelinePage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Investors' },
  },
]
